import {ActionTree} from "vuex";
import {AwardsWidgetState} from "@/apps/AwardsWidget/models/awards-widget-state";

export default <ActionTree<AwardsWidgetState, AwardsWidgetState>>{
    async onClick(context, category) {
        if (category.categories.length <= 0) {
            context.commit('setRecipientsLimit', 10);
            context.commit('setSelectedCategory', category);

            context.state.categories.forEach((parent) => {
                parent.selected =
                    parent === context.state.selectedCategory ||
                    parent.categories.indexOf(context.state.selectedCategory) >= 0;

                parent.categories.forEach((child) => {
                    child.selected = child === context.state.selectedCategory;
                })
            })
        }
    },

    async findInitiallySelectedCategory(context, categories) {
        for (let i = 0; i < categories.length; i++) {
            let item = categories[i];

            if (item.recipients?.length > 0) {
                return item;
            }

            let subItem = context.getters.findInitiallySelectedCategory(item.categories);

            if (subItem) {
                return subItem;
            }
        }
    },

    async init(context, categories) {
        let category = await context.dispatch('findInitiallySelectedCategory', categories);

        if (category) {
            await context.commit('setSelectedCategory', category)
        }

        await context.dispatch('onClick', category);
    }
}
